<template>
  <div class="ys-data-table">
    <el-card v-if="showForm" style="margin-bottom: 10px">
      <div v-if="$slots.title" slot="header">
        <slot name="title" />
      </div>
      <el-form
        ref="searchForm"
        :label-width="labelWidth"
        :size="size"
        :show-message="false"
        inline
        @keyup.enter.native.prevent="handleSearch"
      >
        <el-form-item
          v-for="(item, index) in list"
          :key="index"
          :label="item.label"
          :label-width="item.labelWidth"
        >
          <ys-input
            v-if="item.tag === 'input'"
            v-model="searchParam[item.field]"
            v-bind="{
              clearable: true,
              placeholder: '请输入',
              ...(item.props || {}),
            }"
          >
            <span v-if="item.prepend" slot="prepend">{{ item.prepend }}</span>
            <span v-if="item.append" slot="append">{{ item.append }}</span>
          </ys-input>
          <el-select
            v-if="item.tag === 'select'"
            v-model="searchParam[item.field]"
            v-bind="{
              clearable: true,
              filterable: true,
              ...(item.props || {}),
            }"
            @change="handleSelectChange($event, item)"
          >
            <template v-if="item.optionsField">
              <el-option
                v-for="(option, i) in depOptionMap[item.optionsField]"
                :key="i"
                :value="option[item.valueKey] || option.value"
                :label="option[item.labelKey] || option.label"
              ></el-option>
            </template>
            <template v-else>
              <el-option
                v-for="(option, i) in item.options"
                :key="i"
                :value="option[item.valueKey] || option.value"
                :label="option[item.labelKey] || option.label"
              ></el-option>
            </template>
          </el-select>
          <el-date-picker
            v-if="item.tag === 'date'"
            v-model="searchParam[item.field]"
            v-bind="{
              type: 'date',
              placeholder: '请选择',
              'range-separator': '至',
              'start-placeholder': '开始日期',
              'end-placeholder': '结束日期',
              ...(item.props || {}),
            }"
          ></el-date-picker>
          <el-cascader
            v-if="item.tag === 'cascader'"
            v-model="searchParam[item.field]"
            v-bind="{
              filterable: true,
              options: depOptionMap[item.optionsField] || [],
              ...(item.props || {}),
            }"
          ></el-cascader>
          <template v-else-if="item.tag === 'custom'">
            <slot :name="item.slot" />
          </template>
          <template v-if="item.tag === 'button'">
            <ys-table-button
              v-if="item.render"
              :render="item.render"
            ></ys-table-button>
            <el-button
              v-else
              v-bind="{
                size: 'small',
                ...(item.props || {}),
              }"
              @click="item.event ? $emit(item.event) : ''"
              >{{ item.text || "" }}</el-button
            >
          </template>
        </el-form-item>
        <template v-if="list.length">
          <el-form-item v-if="resetBtn" label-width="0">
            <el-button :loading="value" @click="handleReset">重置</el-button>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button :loading="value" type="primary" @click="handleSearch">
              搜索
            </el-button>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button
              v-if="exportBtn"
              type="success"
              @click="handlePreExport"
              >{{ exportText }}</el-button
            >
          </el-form-item>
        </template>
        <el-form-item v-if="$slots.button" label-width="0">
          <slot name="button" />
        </el-form-item>
        <el-form-item
          v-for="(item, index) in buttonList"
          :key="`button-${index}`"
        >
          <template v-if="item.tag === 'button'">
            <ys-table-button
              v-if="item.render"
              :render="item.render"
            ></ys-table-button>
            <el-button
              v-else
              v-bind="{
                size: 'small',
                ...(item.props || {}),
              }"
              @click="handleClickButton(item)"
              >{{ item.text || "" }}</el-button
            >
          </template>
          <template v-else-if="item.tag === 'custom'">
            <slot :name="item.slot" />
          </template>
        </el-form-item>
        <slot name="form-item" />
      </el-form>
    </el-card>
    <slot name="table-content" />
    <el-card>
      <div v-if="$slots['table-title']" slot="header">
        <slot name="table-title" />
      </div>
      <el-table
        ref="elTable"
        v-loading="loading"
        border
        :data="data.length ? data : tableData"
        :max-height="maxHeight"
        v-bind="tableProps"
        v-on="$listeners"
      >
        <template v-for="(item, index) in formatColumns">
          <el-table-column
            v-if="item.slot"
            :key="index"
            v-bind="{
              ...omitSlot(item),
              prop: item.key || item.prop,
              align: item.align || 'center',
              minWidth: item.minWidth || '100',
            }"
          >
            <template #default="scope">
              <span>
                <slot
                  :name="item.slot"
                  :row="scope.row"
                  :column="scope.column"
                  :index="scope.$index"
                />
              </span>
            </template>
          </el-table-column>
          <!-- 多表头嵌套 -->
          <el-table-column
            v-else-if="item.columns"
            v-bind="{
              ...omitSlot(item),
              prop: item.key || item.prop,
              align: item.align || 'center',
              minWidth: item.minWidth || '100',
            }"
            :key="'chileColumnsKey' + index"
            :label="item.label"
          >
            <template v-for="(childItem, childIndex) in item.columns">
              <el-table-column
                v-if="childItem.slot"
                :key="childIndex"
                v-bind="{
                  ...omitSlot(childItem),
                  prop: childItem.key || childItem.prop,
                  align: childItem.align || 'center',
                  minWidth: childItem.minWidth || '100',
                }"
              >
                <template #default="scope">
                  <span>
                    <slot
                      :name="childItem.slot"
                      :row="scope.row"
                      :column="scope.column"
                      :index="scope.$index"
                    />
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                v-else
                :key="'else' + childIndex"
                v-bind="{
                  ...childItem,
                  prop: childItem.key || childItem.prop,
                  align: childItem.align || 'center',
                  minWidth: childItem.minWidth || '100',
                }"
              >
              </el-table-column>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            v-bind="{
              ...item,
              prop: item.key || item.prop,
              align: item.align || 'center',
              minWidth: item.minWidth || '100',
            }"
          >
            <div v-if="item.popover" slot="header">
              <span>{{ item.label }}</span>
              <el-popover v-bind="item.popover">
                <i
                  v-if="
                    item.popover.slot && item.popover.slot.startsWith('el-icon')
                  "
                  slot="reference"
                  :style="item.popover.slotStyle"
                  :class="[item.popover.slot]"
                />
                <span
                  v-else
                  slot="reference"
                  :style="item.popover.slotStyle"
                  v-html="item.popover.slot"
                />
              </el-popover>
            </div>
          </el-table-column>
        </template>
        <div v-if="$slots.append" slot="append">
          <slot name="append" />
        </div>
      </el-table>
      <el-pagination
        v-if="usePagination"
        :total="total"
        :current-page="pagination.page"
        :page-size="pagination.pageSize"
        :page-sizes="pageSizes"
        style="text-align: center; margin-top: 10px"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleChangePage"
        @size-change="handleChangePageSize"
      ></el-pagination>
    </el-card>
  </div>
</template>
<script>
import YsTableButton from "../YsForm/YsTableButton.js";
import { downloadArrayBuffer } from "@/utils/export.js";
import { getFileName } from "@/utils/utils.js";
import { isObject, isFunction, isString } from "@/utils/tools/type.js";
import apiBaseURL from "@/utils/baseUrl.js";

const mixinAlignCenter = (item) => {
  if (item.children) {
    item.children = mixinAlignCenter(item.children);
  }
  return {
    align: "center",
    ...item,
  };
};
export default {
  name: "YsDataTable",
  components: { YsTableButton },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    /**
     * 传入的自定义 data 数据
     * 如果数据存在(数字长度不为0)，则只展示这里的数据，内部 tableData 将失效
     */
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * 用于控制是否触发请求
     * 常用场景：1、首次进入请求；2、父组件主动调用刷新
     */
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * 初始搜索参数
     * 通常用于url传值，或默认值
     */
    initParams: {
      type: Object,
      default: () => ({}),
    },
    labelWidth: {
      type: String,
      default: "70",
    },
    size: {
      type: String,
      default: "small",
    },
    /**
     * 生成表单的json scheme
     *  tag: input | select | date | cascader
     *  label: String，标签名
     *  labelWidth：String，标签名宽度
     *  field：String，属性名，即表单项value所对应的字段名
     *  transform：Function，对最终输出的字段值做处理，如将date转换为时间戳
     *  defaultValue: Any，field的默认值，即该表单项输出的默认值，{ [field]: defaultValue }
     *  props: 对应元素所含有的属性值，即支持view UI对应组件的所有属性
     *
     *  ----------------input特有项，详见Input组件--------------
     *  prepend: Input 前置slot
     *  append: Input 后置slot
     *
     *  ----------------select特有项，详见Select组件--------------
     *  options：Select 的选择列表
     */
    list: {
      type: Array,
      default: () => [],
    },
    /**
     * 按钮列表
     */
    buttonList: {
      type: Array,
      default: () => [],
    },
    /**
     * 是否显示重置按钮
     */
    resetBtn: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示导出按钮
     */
    exportBtn: {
      type: Boolean,
      default: false,
    },
    /**
     * 同步导出方法
     */
    exportSync: {
      type: Function,
      default: null,
    },
    /**
     * 异步导出方法
     */
    exportAsync: {
      type: Function,
      default: null,
    },
    /**
     * 是否使用export字段 (即is_export: 1) 导出
     *  若有值，则直接使用fetchMethod方法导出
     */
    useExport: {
      validator(value) {
        return ["", "sync", "async"].includes(value);
      },
      default: "",
    },
    columns: {
      type: Array,
      default: () => [],
    },
    /**
     * 请求方法
     */
    fetchMethod: {
      type: Function,
      default: null,
    },
    /**
     * 请求结果处理方法, 部分接口不满足通用的数据结构，可以使用此参数特殊处理
     * return { list: Array } | required
     */
    fetchResultTransform: {
      type: Function,
    },
    /**
     * 是否使用分页
     */
    usePagination: {
      type: Boolean,
      default: true,
    },
    /**
     * 分页数，默认20条一页
     */
    pageSize: {
      type: Number,
      default: 20,
    },
    /**
     * 分页别名
     */
    pageAlias: {
      type: String,
      default: "page",
    },
    /**
     * 分页数别名
     */
    pageSizeAlias: {
      type: String,
      default: "page_size",
    },
    /**
     * 分页数选择器
     */
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100, 200, 500, 1000],
    },
    /**
     * 导出按钮文本
     */
    exportText: {
      type: String,
      default: "导出",
    },
    /**
     * 请求前回调
     */
    beforeFetch: {
      type: Function,
    },
    /**
     * 返回的列表字段名
     */
    listField: {
      type: String,
      default: "list",
    },
    /**
     * 是否使用arraybuffer进行导出
     */
    useArrayBuffer: {
      type: Boolean,
      default: false,
    },
    /**
     * 搜索数据处理函数
     */
    transformParams: {
      type: Function,
    },
    /**
     * 总数别名
     */
    totalAlias: {
      type: String,
      default: "",
    },
    /**
     * 表格高度
     */
    maxHeight: {
      type: String,
      default: "auto",
    },
    /**
     * 文件名
     */
    fileName: {
      type: String,
      default: "",
    },
    /**
     * 导出字段
     */
    exportField: {
      type: String,
      default: "is_export",
    },
    /**
     * 表格属性
     */
    tableProps: {
      type: Object,
      default: () => ({}),
    },
    /**
     * 是否是非包装的返回结果
     */
    useDataField: {
      type: Boolean,
      default: false,
    },
    /**
     * list 中的 select options，因为可能是从接口获取的
     */
    depOptionMap: {
      type: Object,
      default: () => ({}),
    },
    /**
     * 下拉选择回调
     */
    selectChange: {
      type: Function,
    },
    /**
     * 保持上一次的结果，默认保持
     * 场景：当请求接口出错，是否需要重置数据
     */
    keepLastResult: {
      type: Boolean,
      default: true,
    },
    /**
     * 重置是否发起请求
     */
    isResetFetch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchParam: {},
      loading: false,
      total: 0,
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 20,
      },
    };
  },
  computed: {
    showForm() {
      return !!(
        this.list.length ||
        this.$slots.title ||
        this.buttonList.length
      );
    },
    formatColumns() {
      return this.columns.map((item) => {
        return mixinAlignCenter(item);
      });
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.$nextTick(this.handleFetch);
        }
      },
      immediate: true,
    },
    list: {
      handler() {
        this.handleInitSearch();
      },
    },
    searchParam: {
      handler() {
        this.$emit("on-change", this.handleTransform());
      },
      deep: true,
    },
  },
  created() {
    this.handleInitSearch();
    this.handleInitPagination();
  },
  methods: {
    omitSlot(obj) {
      const { slot, ...params } = obj;
      return params;
    },
    handleInitSearch(type) {
      // type 为 reset 的时候，重置为 defaultValue 的值，否则保留 initParams 的值
      const params = { ...this.initParams };
      this.list.forEach((item) => {
        params[item.field] =
          item.defaultValue ||
          (type === "reset" ? "" : params[item.field] || "");
      });
      this.searchParam = params;
    },
    handleInitPagination() {
      this.pagination = {
        page: 1,
        pageSize: this.pageSize,
      };
    },
    // 格式化搜索数据
    handleTransform() {
      let params = { ...this.initParams };
      this.list.forEach((item) => {
        if (typeof item.transform === "function") {
          params = {
            ...params,
            ...item.transform(this.searchParam[item.field]),
          };
        } else {
          params[item.field] = this.searchParam[item.field];
        }
      });
      params =
        this.transformParams && this.transformParams(params)
          ? this.transformParams(params)
          : params;
      return params;
    },
    handleTransformPagination() {
      const { page, pageSize } = this.pagination;
      return {
        [this.pageAlias]: page,
        [this.pageSizeAlias]: pageSize,
      };
    },
    handleReset() {
      this.handleInitSearch("reset");
      this.handleInitPagination();
      this.$emit("on-reset", this.handleTransform());
      if (this.isResetFetch) {
        this.handleFetch();
      }
    },
    handleSearch() {
      this.handleInitPagination();
      this.$emit("on-search", this.handleTransform());
      this.handleFetch();
    },
    // 导出前校验函数
    handlePreExport() {
      const params = this.handleTransform();
      if (!this.beforeFetch) {
        this.handleExport();
        return;
      }
      const before = this.beforeFetch(params);
      if (before && before.then) {
        before.then(() => this.handleExport());
      } else {
        this.handleExport();
      }
    },
    handleExport() {
      const params = this.handleTransform();
      if (this.useExport === "sync" || this.exportSync) {
        const promise =
          this.useExport === "sync"
            ? this.fetchMethod(
                { ...params, [`${this.exportField}`]: 1 },
                this.useArrayBuffer
              )
            : this.exportSync(
                { ...params, [`${this.exportField}`]: 1 },
                this.useArrayBuffer
              );
        promise.then(
          (res) => {
            if (this.useArrayBuffer) {
              const filename =
                this.fileName || getFileName(res.headers) || "excel";
              downloadArrayBuffer({ data: res.data, filename });
            } else if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          },
          (e) => {
            this.$emit("on-export-error", e);
          }
        );
        // } else if (this.useExport === "async" || this.exportAsync) {
        //   const promise =
        //     this.useExport === "async"
        //       ? this.fetchMethod({ ...params, [`${this.exportField}`]: 1 })
        //       : this.exportAsync({ ...params, [`${this.exportField}`]: 1 });
        //   promise.then(
        //     () => {
        //       /* 显示下载中心 */
        //       this.$store.state.showDownloadModal = true;
        //     },
        //     e => {
        //       /* 显示导出错误信息 */
        //       this.$store.state.downloadErrorMsg = e.msg;
        //       this.$emit("on-export-error", e);
        //     },
        //   );
      } else {
        this.$emit("on-export", params);
      }
    },
    handleFetch() {
      const params = this.handleTransform();
      const pageParams = this.usePagination
        ? this.handleTransformPagination()
        : {};
      const combineParams = { ...params, ...pageParams };
      if (!this.beforeFetch) {
        this.handleGetList(combineParams);
        return;
      }
      const before = this.beforeFetch(combineParams);
      if (before && before.then) {
        before.then(() => this.handleGetList(combineParams));
        this.$emit("input", false);
      } else {
        this.handleGetList(combineParams);
      }
    },
    handleGetList(params) {
      this.loading = true;
      this.$emit("on-loading", true);
      this.fetchMethod(params)
        .then((res) => {
          // 兼容接口直接返回data为数组的情况
          if (Array.isArray(res)) {
            if (typeof this.fetchResultTransform === "function") {
              const { list } = this.fetchResultTransform(res);
              this.tableData = list;
            } else {
              this.tableData = res;
            }
            this.total = res.length;
          } else if (this.useDataField) {
            const data = res;
            const { total, count, total_size: totalSize } = data;
            const validTotal = [total, count, totalSize].find(Boolean);
            if (validTotal) {
              this.total = Number(validTotal);
            } else if (this.totalAlias && res[this.totalAlias]) {
              this.total = Number(res[this.totalAlias]);
            } else {
              this.total = 0;
            }
            if (typeof this.fetchResultTransform === "function") {
              const { list } = this.fetchResultTransform(data);
              this.tableData = list;
            } else {
              this.tableData = data[this.listField];
            }
            this.$emit("on-fetch-success", data);
          } else {
            const { code, data, msg } = res.data;
            if (String(code) === "200") {
              const { total, count, total_size: totalSize } = data;
              const validTotal = [total, count, totalSize].find(Boolean);
              if (validTotal) {
                this.total = Number(validTotal);
              } else if (this.totalAlias && res[this.totalAlias]) {
                this.total = Number(res[this.totalAlias]);
              } else {
                this.total = 0;
              }
              if (typeof this.fetchResultTransform === "function") {
                const { list } = this.fetchResultTransform(data);
                this.tableData = list;
              } else {
                this.tableData = data[this.listField];
              }
              this.$emit("on-fetch-success", data);
            } else {
              this.$message.error(msg);
              this.$emit("on-fetch-error", data);
            }
          }
        })
        .catch((e) => {
          if (!this.keepLastResult) {
            this.total = 0;
            this.tableData = [];
          }
          this.$emit("on-fetch-error", e);
        })
        .finally(() => {
          this.loading = false;
          this.$emit("on-loading", false);
          this.$emit("input", false);
        });
    },
    handleChangePage(value) {
      this.pagination.page = value;
      this.$emit("on-page-change", this.handleTransformPagination());
      this.handleFetch();
    },
    handleChangePageSize(value) {
      const isFirstPage = this.pagination.page === 1;
      this.pagination = {
        page: 1,
        pageSize: value,
      };
      // 若是第一页，则直接触发回调，否则将传递给handleChangePage方法触发回调
      if (isFirstPage) {
        this.$emit("on-page-change", this.handleTransformPagination());
      }
      this.handleFetch();
    },
    /**
     * 更新特定项，供父组件调用
     * @param index
     * @param searchParams
     * eg: this.$refs.ysSearchTable.update(1, {id: 1})
     */
    update(index, searchParams = {}) {
      if (typeof index !== "number") {
        return;
      }
      this.fetchMethod(searchParams)
        .then((res) => {
          if (this.useDataField) {
            const data = res;
            let list = data[this.listField];
            if (typeof this.fetchResultTransform === "function") {
              list = this.fetchResultTransform(data).list;
            }
            this.tableData.splice(index, 1, list[0]);
            this.$emit("on-update-success", index, list[0]);
          } else {
            const { code, data, msg } = res.data;
            if (String(code) === "200") {
              let list = data[this.listField];
              if (typeof this.fetchResultTransform === "function") {
                list = this.fetchResultTransform(data).list;
              }
              this.tableData.splice(index, 1, list[0]);
              this.$emit("on-update-success", index, list[0]);
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.$emit("on-update-error", index, searchParams);
        });
    },
    /**
     * public
     * 更新特定项，供父组件调用
     * @param index
     * @param rowData
     * eg: this.$refs.ysSearchTable.update(1, rowData)
     */
    updateIndex(index, rowData) {
      this.tableData.splice(index, 1, rowData);
    },
    /**
     * 更新全列表，供父组件调用
     * @param list
     * eg: this.$refs.ysSearchTable.update(list)
     */
    updateAll(list) {
      if (!Array.isArray(list)) {
        return;
      }
      this.tableData = list.slice();
    },
    /**
     * 切换勾选状态
     */
    toggleRowSelection(index, selected) {
      const _this = this;
      _this.$refs.elTable.toggleRowSelection(_this.tableData[index], selected);
    },
    /**
     * 清空所有筛选项，供父组件调用
     * eg: this.$refs.ysSearchTable.reset()
     */
    reset() {
      const _this = this;
      this.$nextTick(_this.handleReset);
    },
    /**
     * 导出，供父组件调用
     * eg: this.$refs.ysSearchTable.exportExcel()
     */
    exportExcel() {
      this.handleExport();
    },
    /**
     * 清空分页选项，供父组件调用
     * eg: this.$refs.ysSearchTable.initPageValue()
     */
    initPageValue() {
      this.handleInitPagination();
    },
    /**
     * 点击按钮
     */
    handleClickButton(item) {
      const { event } = item;
      if (isObject(event)) {
        const { handler, success, fail, completed } = event;
        const promise = handler(this.handleTransform());
        if (promise && promise.then) {
          promise
            .then((res) => {
              if (isFunction(success)) {
                success(res);
              } else if (isString(success)) {
                success && this.$emit(success, res);
              } else {
                return res;
              }
            })
            .catch((e) => {
              if (isFunction(fail)) {
                fail(e);
              } else if (isString(fail)) {
                fail && this.$emit(fail, e);
              } else {
                return e;
              }
            })
            .finally(() => {
              if (isFunction(completed)) {
                completed();
              } else if (isString(completed)) {
                completed && this.$emit(completed);
              }
            });
        } else {
          // 成功回调
          if (isFunction(success)) {
            success(promise);
          } else if (isString(success)) {
            success && this.$emit(success, promise);
          }
          // 完成回调
          if (isFunction(completed)) {
            completed(promise);
          } else if (isString(completed)) {
            completed && this.$emit(completed, promise);
          }
        }
      } else if (isString(item.event)) {
        switch (item.event) {
          case "export": {
            this.handlePreExport();
            break;
          }
          case "upload": {
            // todo this.handleUpload
            break;
          }
          // case "download": {
          //     // todo this.handleDownload
          //     break;
          // }
          default: {
            this.$emit(item.event, this.handleTransform());
          }
        }
      }
    },
    /**
     * 下拉选择回调，用于改变 searchParams 的值
     */
    handleSelectChange(value, item) {
      if (!this.selectChange) {
        return;
      }
      this.searchParam = this.selectChange(item, this.searchParam);
    },
  },
};
</script>
<style scoped>
.ys-data-table .el-form .el-form-item {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageComponents/YsDataTable.vue